export const SET_ERROR = "@bookings/SET_ERROR";
export const SET_BOOKING = "@bookings/SET_BOOKING";
export const RESET_STATE = "@bookings/RESET_STATE";
export const SET_FORM_EXTENSION = "@bookings/SET_FORM_EXTENSION";

export const GET_BOOKING_REQUEST = "@bookings/GET_BOOKING_REQUEST";
export const GET_BOOKING_SUCCESS = "@bookings/GET_BOOKING_SUCCESS";
export const GET_BOOKING_FAILURE = "@bookings/GET_BOOKING_FAILURE";

export const UPDATE_BOOKING_REQUEST = "@bookings/UPDATE_BOOKING_REQUEST";
export const UPDATE_BOOKING_SUCCESS = "@bookings/UPDATE_BOOKING_SUCCESS";
export const UPDATE_BOOKING_FAILURE = "@bookings/UPDATE_BOOKING_FAILURE";

export const SELECT_BOOKING_REQUEST = "@bookings/SELECT_BOOKING_REQUEST";
export const SELECT_BOOKING_SUCCESS = "@bookings/SELECT_BOOKING_SUCCESS";
export const SELECT_BOOKING_FAILURE = "@bookings/SELECT_BOOKING_FAILURE";

export const CREATE_BOOKING_REQUEST = "@bookings/CREATE_BOOKING_REQUEST";
export const CREATE_BOOKING_SUCCESS = "@bookings/CREATE_BOOKING_SUCCESS";
export const CREATE_BOOKING_FAILURE = "@bookings/CREATE_BOOKING_FAILURE";

export const SEARCH_BOOKING_REQUEST = "@bookings/SEARCH_BOOKING_REQUEST";
export const SEARCH_BOOKING_SUCCESS = "@bookings/SEARCH_BOOKING_SUCCESS";
export const SEARCH_BOOKING_FAILURE = "@bookings/SEARCH_BOOKING_FAILURE";